import { z } from 'zod';
export const trainingAssessmentResultNotificationEventName = 'training.assessment-result-notification-requested.v1';
export const trainingAssessmentResultNotificationCapability = 'training.assessment-result-notification-intent.v1';
export const trainingAssessmentResultNotificationPayloadSchema = z.strictObject({
    notificationKind: z.literal('training-assessment-result'),
    learnerMembershipId: z.string().uuid(),
    recipientRoleKeys: z.tuple([z.literal('manager'), z.literal('owner')]),
    requestedChannels: z.tuple([z.literal('email'), z.literal('in-app')]),
    courseId: z.string().uuid(),
    releaseId: z.string().uuid(),
    attemptId: z.string().uuid(),
    attemptNumber: z.number().int().positive(),
    courseTitle: z.string().trim().min(1).max(250),
    assessmentTitle: z.string().trim().min(1).max(250),
    scoreBasisPoints: z.number().int().min(0).max(10_000),
    passed: z.boolean(),
    submittedAt: z.string().datetime({ offset: true }),
    actionPath: z.literal('/training/grades'),
});
//# sourceMappingURL=training-assessment-result-notification.contract.js.map